import React from "react";
import { Button } from "components/buttons";
import { general as texts } from "assets/strings/texts";

const PerhourFormModel = ({
  billingObj,
  hourAmount,
  handleInputHourAmount,
  overnightAmount,
  handleInputOvernightAmount,
  handlePerHourSubmit,
  className,
}) => {
  return (
    <div className={className}>
      <p>Tarifa por hora</p>
      <div className="input-section">
        <input
          required
          id="rate"
          min="0.01"
          max="any"
          type="text"
          name="amount"
          autoComplete="off"
          placeholder="Nueva Tarifa"
          value={hourAmount}
          onChange={handleInputHourAmount}
        />
      </div>
      {billingObj.overnight && <p>Pernocta</p>}
      {billingObj.overnight && (
        <div className="input-section">
          <input
            required
            id="rate"
            min="0.01"
            max="any"
            type="text"
            name="amount"
            autoComplete="off"
            placeholder="Nueva Tarifa"
            value={overnightAmount}
            onChange={handleInputOvernightAmount}
          />
        </div>
      )}
      <Button color="blue" onClick={handlePerHourSubmit}>
        {texts.accept}
      </Button>
    </div>
  );
};

export { PerhourFormModel };
